import { useEffect } from 'react';
import { TEST_CONNECTION_STATUS } from 'network/httpClients/RepositoryClient/consts';
import { useTestGitInstallationConnectionQuery } from 'network/queries/useTestGitInstallationConnectionQuery';
import { InstallationStatusMessage, Step } from 'shared/InstallationDialog';
import { useMultiStepDialog } from 'shared/MultiStepDialog';
import { spawn } from 'utils/translations';
import { Loader } from '../../Loader';
import { useGithubInstallation } from '../githubInstallationContext';

export const CheckConnection = () => {
  const spawnCheckConnection = spawn(
    'dialogs.github-installation.check-connection',
  );
  const { setIsNextEnabled } = useMultiStepDialog();
  const { isConnectionSuccessful, setIsConnectionSuccessful, installationId } =
    useGithubInstallation();

  const {
    data: testConnectionData,
    isFetched: isTestConnectionFetched,
    isFetching: isTestConnectionFetching,
    refetch: testConnectionRefetch,
  } = useTestGitInstallationConnectionQuery(installationId, {
    enabled: !!installationId,
  });

  useEffect(() => {
    if (testConnectionData) {
      setIsConnectionSuccessful(
        testConnectionData.status === TEST_CONNECTION_STATUS.OK,
      );
    }
  }, [testConnectionData]);

  useEffect(() => {
    setIsNextEnabled(isConnectionSuccessful);
  }, [isConnectionSuccessful]);

  const renderStatusMessage = () => {
    if (isConnectionSuccessful) {
      return (
        <InstallationStatusMessage
          status="success"
          message={spawnCheckConnection('success')}
        />
      );
    }

    if (!isTestConnectionFetched) {
      return <Loader />;
    }

    return (
      <InstallationStatusMessage
        status="error"
        message={spawnCheckConnection('error')}
        retryLabel={spawnCheckConnection('test-connection-button')}
        onRetry={testConnectionRefetch}
        isRetrying={isTestConnectionFetching}
      />
    );
  };

  return <Step>{renderStatusMessage()}</Step>;
};
